import React from 'react';
import styled from 'styled-components';

import { ModalProps } from '@tager/web-components';

import { ReactComponent as InProgressIcon } from '@/assets/svg/under-construction.svg';
import Helper from '@/components/Helper';
import { Header, HeaderTitle } from '@/components/modals/shared/styles';
import CloseButton from '@/components/modals/shared/CloseButton';
import { colors } from '@/constants/theme';
import { useBodyPositionFixed } from '@/hooks/useBodyPositionFixed';

type Props = ModalProps<{
  title: string;
}>;

function InProgressForm({ innerProps, closeModal }: Props) {
  const { title } = innerProps;

  useBodyPositionFixed();

  return (
    <Component>
      <Content>
        <Header>
          <HeaderTitle>{title}</HeaderTitle>
          <StyledCloseButton onClick={closeModal} />
        </Header>
        <Main>
          <StyledIcon />
        </Main>
        <Bottom>
          <Helper />
        </Bottom>
      </Content>
    </Component>
  );
}

export default InProgressForm;

const Component = styled.div`
  height: min(calc(var(--vh, 1) * 100), 80vh);
  min-width: min(100vw, 500px);
  padding-bottom: 15px;
  background: #fff;
  flex-shrink: 1;
  -webkit-overflow-scrolling: touch !important;
  overflow: auto !important;
  position: relative;
`;

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
`;

const StyledIcon = styled(InProgressIcon)`
  max-width: 150px;
  height: 150px;
`;

const Content = styled.div``;
const Main = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px dashed ${colors.gray50};
`;
const Bottom = styled.div``;
